import Web3 from "web3";

const rpcProvider = process.env.VUE_APP_BOME_RPC_URL;

// 初始化 Web3 实例
const web3 = new Web3(new Web3.providers.HttpProvider(rpcProvider));

export default web3;
